export default __webpack_public_path__ + "static/media/Flag_of_Eswatini.aa0fd5de.svg";